// extracted by mini-css-extract-plugin
export default {"root":"LinkArrow_root__LM2K3","icon":"LinkArrow_icon__6k33y"};